import {
  DeliveryTypeDisplayName,
  LocalStorageEnum,
  OrderTypesEnum,
} from "../enums";
import LS from "../LocalStorage";
import {
  LoyaltyChannel,
  LoyaltyDayOfWeek,
  LoyaltyOrderType,
} from "../loyaltyTypes";

const mapFranchiseDeliveryToLoyaltyOrderType = (
  franchiseDeliveryTypeDisplayName?: string | null
): LoyaltyOrderType => {
  switch (franchiseDeliveryTypeDisplayName) {
    case DeliveryTypeDisplayName.TABLE_DELIVERY:
      return LoyaltyOrderType.HOME_DELIVERY;
    case DeliveryTypeDisplayName.BEACH_DELIVERY:
      return LoyaltyOrderType.BEACH_DELIVERY;
    case DeliveryTypeDisplayName.CAR_PICKUP:
      return LoyaltyOrderType.DRIVE_THRU;
    case DeliveryTypeDisplayName.OFFICE_DELIVERY:
      return LoyaltyOrderType.OFFICE_DELIVERY;
    case DeliveryTypeDisplayName.CABIN_DELIVERY:
      return LoyaltyOrderType.CABIN_DELIVERY;
    default:
      return LoyaltyOrderType.HOME_DELIVERY;
  }
};

export const mapToLoyaltyOrderType = (
  orderType: OrderTypesEnum,
  franchiseDeliveryTypeDisplayName?: string | null
): LoyaltyOrderType | null => {
  switch (orderType) {
    case OrderTypesEnum.DINE_IN:
      return LoyaltyOrderType.DINE_IN;
    case OrderTypesEnum.TAKE_OUT:
      return LoyaltyOrderType.PICK_UP;
    case OrderTypesEnum.DELIVERY:
    case OrderTypesEnum.DELIVERYV2:
      return mapFranchiseDeliveryToLoyaltyOrderType(
        franchiseDeliveryTypeDisplayName
      );
    default:
      return null;
  }
};

export const getLoyaltyChannel = (): LoyaltyChannel => {
  const isMobileApp =
    LS._get(LocalStorageEnum.MOBILE_APP_PARTNER) === "true" ||
    LS._get(LocalStorageEnum.MOBILE_APP_RESTAURANT) === "true";
  const isSelfService = JSON.parse(
    LS._get(LocalStorageEnum.SELF_SERVICE) ?? "false"
  );

  if (isSelfService) {
    return LoyaltyChannel.SELF_SERVICE;
  }
  if (isMobileApp) {
    return LoyaltyChannel.MOBILE_APP;
  }

  return LoyaltyChannel.WEB_APP;
};

const weekdayMap: Record<number, LoyaltyDayOfWeek> = {
  0: LoyaltyDayOfWeek.SUN,
  1: LoyaltyDayOfWeek.MON,
  2: LoyaltyDayOfWeek.TUE,
  3: LoyaltyDayOfWeek.WED,
  4: LoyaltyDayOfWeek.THU,
  5: LoyaltyDayOfWeek.FRI,
  6: LoyaltyDayOfWeek.SAT,
};

export const mapWeekdayToLoyaltyDayOfWeek = (
  weekday: number
): LoyaltyDayOfWeek => {
  return weekdayMap[weekday];
};
